/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditCardProduct
 */
export interface CreditCardProduct {
    /**
     * 
     * @type {string}
     * @memberof CreditCardProduct
     */
    creditCardProductName: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardProduct
     */
    institutionCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardProduct
     */
    institutionName: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardProduct
     */
    rewardsProgram?: string | null;
}

/**
 * Check if a given object implements the CreditCardProduct interface.
 */
export function instanceOfCreditCardProduct(value: object): value is CreditCardProduct {
    if (!('creditCardProductName' in value) || value['creditCardProductName'] === undefined) return false;
    if (!('institutionCode' in value) || value['institutionCode'] === undefined) return false;
    if (!('institutionName' in value) || value['institutionName'] === undefined) return false;
    return true;
}

export function CreditCardProductFromJSON(json: any): CreditCardProduct {
    return CreditCardProductFromJSONTyped(json, false);
}

export function CreditCardProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCardProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'creditCardProductName': json['credit_card_product_name'],
        'institutionCode': json['institution_code'],
        'institutionName': json['institution_name'],
        'rewardsProgram': json['rewards_program'] == null ? undefined : json['rewards_program'],
    };
}

export function CreditCardProductToJSON(json: any): CreditCardProduct {
    return CreditCardProductToJSONTyped(json, false);
}

export function CreditCardProductToJSONTyped(value?: CreditCardProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credit_card_product_name': value['creditCardProductName'],
        'institution_code': value['institutionCode'],
        'institution_name': value['institutionName'],
        'rewards_program': value['rewardsProgram'],
    };
}

